module.exports = __webpack_public_path__ + "static/media/TUNE_4052.85dd0170.jpg";